import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeAdditionalProductCostReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductTypeAdditionalProductCostReference');
  }
  getAll(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetAll`);
  }

  getForProductType(productType: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/ProductType?productType=${productType}`);
  }
}
